import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("shimmer-styles__shimmerbarbase-2nlzsl", {
  backgroundSize: "1000px 100%",
  animation: "static-styles-shimmer-styles-kf-1k7bnsqi 3s ease-in-out infinite",
  borderRadius: "4px"
});
const _staticStyles2 = _cssRef("shimmer-styles__shimmerherothemeaware-2nlzsl", {
  backgroundSize: "1000px 100%",
  animation: "static-styles-shimmer-styles-kf-1k7bnsqi 3s ease-in-out infinite",
  borderRadius: "4px"
});
const _staticStyles3 = _cssRef("shimmer-styles__shimmerherothemeaware-1uvkat", {
  background: "linear-gradient(90deg, rgba(46, 46, 46, 0.09) 25%, rgba(46, 46, 46, 0.16) 50%, rgba(46, 46, 46, 0.09) 75%)",
  "@media (prefers-color-scheme: dark)": {
    background: "linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%)"
  },
  "[data-hero-theme=\"dark\"] &": {
    background: "linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%)"
  },
  "[data-hero-theme=\"light\"] &": {
    background: "linear-gradient(90deg, rgba(46, 46, 46, 0.09) 25%, rgba(46, 46, 46, 0.16) 50%, rgba(46, 46, 46, 0.09) 75%)"
  }
});
const _staticStyles4 = _cssRef("shimmer-styles__shimmeronlightpanel-2nlzsl", {
  backgroundSize: "1000px 100%",
  animation: "static-styles-shimmer-styles-kf-1k7bnsqi 3s ease-in-out infinite",
  borderRadius: "4px"
});
const _staticStyles5 = _cssRef("shimmer-styles__shimmeronlightpanel-3d7qeo", {
  backgroundColor: "rgba(46, 46, 46, 0.06)",
  backgroundImage: "linear-gradient(90deg, rgba(46, 46, 46, 0.10) 25%, rgba(46, 46, 46, 0.20) 50%, rgba(46, 46, 46, 0.10) 75%)"
});
const _staticStyles6 = _cssRef("shimmer-styles__shimmerondark-2nlzsl", {
  backgroundSize: "1000px 100%",
  animation: "static-styles-shimmer-styles-kf-1k7bnsqi 3s ease-in-out infinite",
  borderRadius: "4px"
});
const _staticStyles7 = _cssRef("shimmer-styles__shimmerondark-2zfyub", {
  background: "linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%)"
});
import type { SerializedStyles } from "@terraindigital/static-styles-react";
export const skeletonShimmerKeyframes = "static-styles-shimmer-styles-kf-1k7bnsqi";
export const shimmerBarBase: SerializedStyles = _staticStyles;
export const shimmerHeroThemeAware: SerializedStyles = [_staticStyles2, _staticStyles3];
export const shimmerOnLightPanel: SerializedStyles = [_staticStyles4, _staticStyles5];
export const shimmerOnDark: SerializedStyles = [_staticStyles6, _staticStyles7];